import React from 'react';
import { useTranslation } from 'react-i18next';
import Reveal from '../Reveal';
import { STATS } from '../../siteConfig';

function StatsRow() {
  const { t, i18n } = useTranslation();

  const stats = [
    { value: `${STATS.customers.toLocaleString(i18n.language)}+`, label: t('home.stats.customers') },
    { value: `${STATS.drivers}+`, label: t('home.stats.drivers') },
    { value: `${STATS.years}+`, label: t('site.stats.years') },
    { value: '24/7', label: t('home.stats.available') },
  ];

  return (
    <section id="stats" aria-label={t('about.teamStats.title')} className="bg-mist py-10 font-sans lg:py-14">
      <dl className="site-container m-0 grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4">
        {stats.map((stat, i) => (
          <Reveal
            key={stat.label}
            delay={i * 60}
            className="flex flex-col-reverse gap-1 text-center lg:border-0 lg:border-l lg:border-solid lg:border-slate-300 lg:first:border-l-0"
          >
            <dt className="text-sm font-medium text-slate-600 lg:text-base">{stat.label}</dt>
            <dd className="m-0 text-4xl font-extrabold tabular-nums tracking-tight text-navy lg:text-5xl">{stat.value}</dd>
          </Reveal>
        ))}
      </dl>
    </section>
  );
}

export default StatsRow;
